module.exports = __webpack_public_path__ + "static/media/payment-guide-step-1.668e6456.png";